import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";
export const StatisticsByUserItemsColumnsData = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '用户姓名',
            dataIndex: 'customerName',
            key: 'customerName',
            width: 200,
            sorter: false,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
            },
            filteredValue: filteredInfo.customerName || [],
        },
        {
            title: '活跃项目数量',
            dataIndex: 'livenessProjectNum',
            key: 'livenessProjectNum',
            sorter: false,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
            },
            filteredValue: filteredInfo.livenessProjectNum || [],
        },
        {
            title: '非活跃项目数量',
            dataIndex: 'unLivenessProjectNum',
            key: 'unLivenessProjectNum',
            sorter: false,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
            },
            filteredValue: filteredInfo.unLivenessProjectNum || [],
        },
        {
            title: '是否活跃',
            dataIndex: 'vitality',
            key: 'vitality',
            width: 200,
            sorter: false,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'vitality'
            },
            filteredValue: filteredInfo.vitality || [],
        },
        {
            title: '非活跃项目ID',
            dataIndex: 'unLivenessProjectIds',
            key: 'unLivenessProjectIds',
            width: 200,
            sorter: false,
            sortDirections: ["descend", "ascend", "descend"],
            scopedSlots: {
                customRender: 'unLivenessProjectIds'
            },
            filteredValue: filteredInfo.unLivenessProjectIds || [],
        },
    ]
}